import { forwardRef, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';

import { TabContents } from './TabContents';

const TAB_ITEMS = [
  { text: '환자 정보', rule: 'info' },
  { text: '작성 전 동의서', rule: 'process' },
  { text: '제출한 동의서', rule: 'submitted' },
];

const TabContainer = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'info';
  const [rule, setRule] = useState(tab);

  const processFormData = useBoundStore((state) => state.hsptlzForm.processFormData);
  const submittedFormData = useBoundStore((state) => state.hsptlzForm.submittedFormData);

  const selectBarRef = useRef(null);
  const listRef = useRef(null);
  const itemRefs = useRef([]); 
  const innerRefs = useRef({}); 

  const handleTabClick = (next) => {
    setRule(next);
    setSearchParams({ tab: next });
  };

  const isNarrow = () => window.matchMedia('(max-width: 480px)').matches;


  const updateBar = () => {
    const bar = selectBarRef.current;
    const list = listRef.current;
    const li = itemRefs.current[rule];
    const inner = innerRefs.current[rule];
    if (!bar || !list || !li) return;

    const width = inner ? inner.offsetWidth : li.offsetWidth;

    let left = li.offsetLeft; 
    if (inner) {
      const listRect = list.getBoundingClientRect();
      const innerRect = inner.getBoundingClientRect();
      const liRect = li.getBoundingClientRect();

      if (isNarrow()) {
        // 반응형: li의 중앙에 tab-line을 배치 (환자 정보 아래 "중앙")
        left = liRect.left - listRect.left + list.scrollLeft + (liRect.width - width) / 2;
      } else {
        // 기본: tab-inner의 시작점에 맞춤
        left = innerRect.left - listRect.left + list.scrollLeft;
      }
    }

    bar.style.left = `${Math.round(left)}px`;
    bar.style.width = `${Math.round(width)}px`;
  };

  useEffect(() => {
    updateBar();
  }, [rule, processFormData, submittedFormData]);

  useEffect(() => {
    const onResize = () => updateBar();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div className='tab-tit-wrap'>
      <ul ref={listRef}>
        {TAB_ITEMS.map((item) => {
          const count =
            item.rule === 'process'
              ? Object.keys(processFormData).length
              : item.rule === 'submitted'
                ? Object.keys(submittedFormData).length
                : '';
          return (
            <Item
              key={item.rule}
              text={item.text}
              rule={item.rule}
              count={count}
              selected={rule === item.rule}
              handleTabClick={handleTabClick}
              ref={(el) => (itemRefs.current[item.rule] = el)} // li
              innerRef={(el) => (innerRefs.current[item.rule] = el)} // tab-inner
            />
          );
        })}
        <div className='tab-line' ref={selectBarRef}></div>
      </ul>
      <TabContents rule={rule} />
    </div>
  );
};

const Item = forwardRef(({ text, rule, selected, count, handleTabClick, innerRef }, ref) => {
  return (
    <li className={selected ? 'on' : ''} onClick={() => handleTabClick(rule)} ref={ref}>
      <div className='tab-inner' ref={innerRef}>
        <span>{text}</span>
        {rule !== 'info' && <span className='label-count'>{count}</span>}
      </div>
    </li>
  );
});
Item.displayName = 'Item';

export default TabContainer;
